export const noteFormFields = (noteTypes) => [
  {
    type: "text",
    name: "title",
    label: "Title",
    validation: (value) => (!value ? "Title is required" : null),
  },
  {
    type: "textarea",
    name: "description",
    label: "Description"
  },
  {
    type: "select",
    name: "type",
    label: "Type",
    options: Object.entries(noteTypes).map(([key, value]) => ({ key, value })),
  },
];